import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import alertMessages from './alertMessages';
import './Alert.css';

const Alert = ({ type, message, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const messages = useMemo(() => alertMessages, []);
  const finalMessage = message || messages[type] || 'Ação realizada com sucesso!';

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 5000); // mesmo tempo da animação CSS

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!isVisible) return null;

  const alertElement = (
    <div className={`alert-popup ${type}`}>
      <div className="alert-message">{finalMessage}</div>
      <button className="alert-close-btn" onClick={() => { setIsVisible(false); if (onClose) onClose(); }}>
        ✕
      </button>
      <div className="alert-progress" />
    </div>
  );

  return ReactDOM.createPortal(alertElement, document.body);
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func,
};

export default Alert;
